import { MessagesPage } from './pages/MessagesPage';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LoginPage, RegisterPage } from './pages/AuthPages';
import { ParcoursPage } from './pages/ParcoursPage';
import { ModulePage } from './pages/ModulePage';
import { DashboardPage, AdminPage } from './pages/OtherPages';
import { MaMarquePage } from './pages/MaMarquePage';
import { FelicitationsPage } from './pages/FelicitationsPage';
import { ProfilPage } from './pages/ProfilPage';
import { LandingPage } from './pages/LandingPage';
import { LegalPage } from './pages/LegalPage';
import { Spinner } from './components/UI';
import './index.css';

// ── ROUTES PROTÉGÉES ──
function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size={36} /></div>;
  return user ? children : <Navigate to="/connexion" />;
}

function AdminRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Spinner size={36} /></div>;
  if (!user) return <Navigate to="/connexion" />;
  if (!user.isAdmin) return <Navigate to="/parcours" />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to={user.isAdmin ? '/admin' : '/parcours'} /> : children;
}

function ModulePageWrapper() {
  const location = useLocation();
  return <ModulePage key={location.pathname} />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Landing page publique */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/mentions-legales" element={<LegalPage page="mentions" />} />
          <Route path="/confidentialite" element={<LegalPage page="confidentialite" />} />

          {/* Pages publiques */}
          <Route path="/connexion" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/inscription" element={<PublicRoute><RegisterPage /></PublicRoute>} />

          {/* Pages utilisateur connecté */}
          <Route path="/parcours" element={<PrivateRoute><ParcoursPage /></PrivateRoute>} />
          <Route path="/module/:num" element={<PrivateRoute><ModulePageWrapper /></PrivateRoute>} />
          <Route path="/tableau-de-bord" element={<PrivateRoute><MaMarquePage /></PrivateRoute>} />
          <Route path="/felicitations" element={<PrivateRoute><FelicitationsPage /></PrivateRoute>} />
          <Route path="/messages" element={<PrivateRoute><MessagesPage /></PrivateRoute>} />
          <Route path="/ma-marque" element={<PrivateRoute><MaMarquePage /></PrivateRoute>} />

          {/* Admin uniquement */}
          <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
          <Route path="/profil" element={<PrivateRoute><ProfilPage /></PrivateRoute>} />

          {/* 404 */}
          <Route path="*" element={<Navigate to="/connexion" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
